
import AppButton from "./AppButton"
import Article from "./Article"
import preventScrollMixin from "./../mixins/preventScrollMixin"
import Spinner from "./Spinner.vue"

export default {
  name: "Modal",
  components: {
    AppButton,
    Article,
    Spinner
  },
  mixins: [preventScrollMixin],
  props: {
    header: {
      type: String,
      default: ""
    },
    body: {
      type: [Object, Array],
      default: null
    },
    isModalOpen: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: true
    },
    showConfirmBtn: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    hasInputContent: {
      type: Boolean,
      default: false
    },
    isAutofocusDisabled: {
      type: Boolean,
      default: false
    },
    isDesktopWidthExpanded: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    cancelBtnText: {
      type: String,
      default: "Cancel"
    },
    confirmBtnText: {
      type: String,
      default: "Confirm"
    },
    hasSpaceAround: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fullScreenAnimation() {
      return this.isFullScreen ? "slide" : null
    }
  },
  watch: {
    isModalOpen: {
      handler(value) {
        this.preventBodyScroll(value)
        if (!this.isAutofocusDisabled) {
          this.focusingModal()
        }
      },
      immediate: true
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeModal")
    },
    checkKeyEvent(event) {
      const focusableList = this.$refs.modal.querySelectorAll(
        "button, [href], input, select, textarea"
      )
      if (focusableList.length < 2 && event.key === "Tab") {
        event.preventDefault()
        return
      }
      const last = focusableList.length - 1
      if (
        event.key === "Tab" &&
        event.shiftKey === false &&
        event.target === focusableList[last]
      ) {
        event.preventDefault()
        focusableList[0].focus()
      } else if (
        event.key === "Tab" &&
        event.shiftKey === true &&
        event.target === focusableList[0]
      ) {
        event.preventDefault()
        focusableList[last].focus()
      }
    },
    focusingModal() {
      return this.isModalOpen
        ? this.$nextTick(() => this.$refs.modal.focus())
        : null
    }
  }
}
